module.exports = __webpack_public_path__ + "static/media/logo.860d6f54.jpg";